import StatisticPage from '@/pages/StatisticPage/StatisticPage.vue'

export default StatisticPage
